import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    CircularProgress,
    FormHelperText,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import upload from '../../User/assets/upload-design.svg'
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/base/TextareaAutosize";
import NumberInput from "../../User/components/NumberInput";

const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
};

const Textarea = styled(BaseTextareaAutosize)(
    ({ theme }) => `
  box-sizing: border-box;
  width: 100%;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${theme.palette.mode === "dark" ? grey[900] : grey[50]
        };

  &:hover {
    border-color: #e37b00;
  }

  &:focus {
    border-color: #e37b00;
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Customizedorder = ({ setgetCartItems, openDialogcatalogue, setOpenDialogcatalogue, customerId }) => {
    //handle close
    const handleClose = () => {
        setOpenDialogcatalogue(false);
        setCustomDesign({
            size: "",
            fabric: "",
            quantity: 1,
            description: "",
            picture: [],
            procure: "",
            name: ""
        });
        setPreviewImages([]);
        setErrors({
            size: "",
            fabric: "",
            quantity: "",
            description: "",
            picture: "",
            procure: "",
            name: ""
        });
    };

    const [previewImages, setPreviewImages] = useState([]);
    const [loading, setLoading] = useState(false)
    const [customdesign, setCustomDesign] = useState({
        size: "",
        fabric: "",
        quantity: 1,
        description: "",
        picture: [],
        procure: "",
        name: ""
    });
    const [errors, setErrors] = useState({
        size: "",
        fabric: "",
        quantity: 1,
        description: "",
        picture: "",
        procure: "",
        name: ""
    });

    //custom design
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        setCustomDesign({
            ...customdesign,
            picture: files,
        });

        setErrors({ ...errors, picture: "" });
        const previews = files.map((file) => {
            return URL.createObjectURL(file);
        });
        setPreviewImages(previews);
    };

    const handleFabricImageChange = (e) => {
        const file = e.target.files[0];
        setCustomDesign({
            ...customdesign,
            fabric_img: file,
        });
    };

    // remove individual selected image
    const handleRemoveImage = (index) => {
        const updatedPictures = [...customdesign.picture];
        const updatedPreviewImages = [...previewImages];

        updatedPictures.splice(index, 1);
        updatedPreviewImages.splice(index, 1);

        setCustomDesign({ ...customdesign, picture: updatedPictures });
        setPreviewImages(updatedPreviewImages);
    };

    // Validation function
    const validateForm = () => {
        let validationErrors = {};

        if (!customdesign.size) validationErrors.size = "Please select a size";
        if (!customdesign.fabric) validationErrors.fabric = "Please select fabric option";
        if (!customdesign.quantity || customdesign.quantity < 1)
            validationErrors.quantity = "Please enter valid quantity";

        if (customdesign.fabric === "No" && !customdesign.procure) {
            validationErrors.procure = "Please select Procure option";
        }

        if (customdesign.fabric === "Yes" && !customdesign.fabric_img) {
            validationErrors.fabricimg = "Please upload your fabric image";
        }

        if (!customdesign.name) validationErrors.name = "Please enter a name";
        if (!customdesign.description) validationErrors.description = "Please enter design description";

        if (customdesign.picture.length === 0)
            validationErrors.picture = "Please upload at least one design image";

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    //handleCustomizeorder
    const handleCustomizeorder = async () => {
        if (!validateForm()) {
            return;
        }
        try {
            setLoading(true)
            const formData = new FormData();
            formData.append("customer_id", customerId);
            formData.append("size", customdesign.size);
            formData.append("fabric_given", customdesign.fabric === "Yes" ? true : false);
            formData.append("design_kind", "CustomDesign");
            formData.append("quantity", customdesign.quantity);
            formData.append("description", customdesign.description);
            formData.append("name", customdesign.name);
            formData.append("procure", customdesign.procure === "Yes" ? true : false);
            customdesign.picture.forEach((file) => formData.append("picture", file));
            if (customdesign.fabric_img) formData.append("fabric_img", customdesign.fabric_img);

            const response = await instance.post('/Catalogue/addCustomDesign', formData)
            if (response.data.success === true) {
                toast.success(response?.data?.message)
                handleClose();
                setPreviewImages([]);
                setCustomDesign({
                    size: "",
                    fabric: null,
                    quantity: 1,
                    description: "",
                    order_for: "",
                    picture: [],
                    procure: ""
                });
                setgetCartItems(true)
            } else {
                toast.error(response?.data?.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialogcatalogue}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Add customize uploads order
                    <Typography>
                        Add customize uploads to raise the order
                    </Typography>
                </DialogTitle>
                <hr style={{ margin: "10px 0px" }} />
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-admin">
                        <Grid container spacing={2} >
                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth required error={Boolean(errors.size)}>
                                        <InputLabel id="demo-simple-select-label">
                                            Select Size
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Select Size"
                                            name="size"
                                            required
                                            value={customdesign?.size}
                                            onChange={(e) => {
                                                setCustomDesign({ ...customdesign, size: e.target.value });
                                                setErrors({ ...errors, size: "" });
                                            }}
                                        >
                                            {["S", "M", "L", "XL", "XXL", "XXXL"].map((size) => (
                                                <MenuItem key={size} value={size}>{size}</MenuItem>
                                            ))}
                                        </Select>
                                        {errors.size && <FormHelperText>{errors.size}</FormHelperText>}
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth required error={Boolean(errors.fabric)}>
                                        <InputLabel id="demo-simple-select-label">
                                            Do you have fabric?
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Do you have fabric?"
                                            value={customdesign?.fabric}
                                            required
                                            onChange={(e) => {
                                                setCustomDesign({ ...customdesign, fabric: e.target.value });
                                                setErrors({ ...errors, fabric: "" });
                                            }}
                                        >
                                            <MenuItem value="Yes">Yes</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                        </Select>
                                        {errors.fabric && <FormHelperText>{errors.fabric}</FormHelperText>}
                                    </FormControl>
                                </div>
                            </Grid>
                            {customdesign.fabric === "Yes" &&
                                <>
                                    <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                        <div className="admin-textfiled">
                                            <TextField
                                                type="file"
                                                label="Upload Fabric"
                                                accept="image/*"
                                                required
                                                InputLabelProps={{ shrink: true }}
                                                onChange={handleFabricImageChange}
                                                inputProps={{ accept: "image/*" }}
                                                error={Boolean(errors.fabricimg)}
                                                helperText={errors.fabricimg}

                                            />
                                        </div>
                                    </Grid>
                                </>
                            }
                            {customdesign.fabric === "No" &&
                                <>
                                    <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                        <div className="admin-textfiled">
                                            <FormControl
                                                fullWidth
                                                required
                                                error={Boolean(errors.procure)}
                                            >
                                                <InputLabel id="demo-simple-select-label">
                                                    Do you want us to Procure ?
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={customdesign?.procure}
                                                    label="Do you want us to Procure ?"
                                                    onChange={(e) => {
                                                        setCustomDesign({
                                                            ...customdesign,
                                                            procure: e.target.value,
                                                        });
                                                        setErrors({ ...errors, procure: "" });
                                                    }}
                                                    required

                                                >
                                                    <MenuItem value="Yes">Yes</MenuItem>
                                                    <MenuItem value="No">No</MenuItem>
                                                </Select>
                                                {errors.procure && <FormHelperText>{errors.procure}</FormHelperText>}
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </>
                            }
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        required
                                        label="Design Name"
                                        value={customdesign?.name}
                                        onChange={(e) => {
                                            setCustomDesign({ ...customdesign, name: e.target.value });
                                            setErrors({ ...errors, name: "" });
                                        }}
                                        error={Boolean(errors.name)}
                                        helperText={errors.name}
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    {/* <Typography sx={{ fontSize: 15, color: "#8a8a8a", fontFamily: "Poppins sans-serif" }}> Description *</Typography> */}
                                    <TextField
                                        required
                                        label="Description"
                                        // multiline
                                        // minRows={3}
                                        fullWidth
                                        placeholder="Enter Description"
                                        value={customdesign?.description}
                                        onChange={(e) => {
                                            setCustomDesign({ ...customdesign, description: e.target.value });
                                            setErrors({ ...errors, description: "" });
                                        }}
                                        error={Boolean(errors.description)}
                                        helperText={errors.description}
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <InputLabel id="demo-simple-select-label1">
                                        Enter Quantity *
                                    </InputLabel>
                                    <NumberInput
                                        label="Quantity"
                                        required
                                        labelId="demo-simple-select-label1"
                                        value={customdesign.quantity}
                                        onChange={(event, newValue) => {
                                            if (newValue >= 1 && newValue <= 100) {
                                                setCustomDesign({ ...customdesign, quantity: newValue });
                                                setErrors({ ...errors, quantity: "" });
                                            }
                                        }}
                                        min={1}
                                        max={100}
                                        error={Boolean(errors.quantity)}
                                    />
                                </div>

                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                <FormControl fullWidth error={Boolean(errors.picture)}>
                                    <div className='upload-image-preview'>
                                        <div className='file-upload-image'>
                                            <Typography variant='h5'>Upload your designs *</Typography>
                                            <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                                                <img src={upload} alt="upload" />
                                            </label>
                                            <input
                                                id="file-upload"
                                                type="file"
                                                name="picture"
                                                accept="image/*"
                                                multiple
                                                onChange={handleFileChange}
                                                style={{ display: "none" }}
                                            />
                                        </div>
                                    </div>
                                    {errors.picture && (
                                        <FormHelperText>{errors.picture}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>


                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                {previewImages.length > 0 && (
                                    <Grid item xs={12}>
                                        <div className="categoryimage-preview">
                                            <ul>
                                                {previewImages.map((src, index) => (
                                                    <li key={index} style={{ position: "relative" }}>
                                                        <img src={src} alt="Selected Design" />

                                                        {/* Remove icon */}
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleRemoveImage(index)}
                                                            sx={{
                                                                position: "absolute",
                                                                top: -8,
                                                                right: -8,
                                                                backgroundColor: "white",
                                                                padding: "12px",
                                                                borderRadius: "50%",
                                                                boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                                                                color: "#ff0000",
                                                                width: "20px",
                                                                height: "20px",
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className="add-btn" disabled={loading} onClick={handleCustomizeorder}>
                        {loading ? <CircularProgress size={20} color="#fff" /> : "Order"}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    )
}

export default Customizedorder;

